import React from "react";
import T from "prop-types";
import Create from "./CreateNote";

class NewNote extends React.Component {
  static propTypes = {
    id: T.number.isRequired,
    important: T.bool,
    initialValues: T.shape({}),
    minor: T.bool,
    trace: T.bool,
    resourceType: T.string.isRequired,
    notesType: T.string
  };

  state = {
    open: false
  };

  close = () => this.setState({ open: false });

  open = () => this.setState({ open: true });

  render() {
    const {
      id,
      resourceType,
      important,
      initialValues = {},
      minor,
      trace,
      notesType
    } = this.props;

    const { open } = this.state;
    return (
      <button
        onClick={this.open}
        className="btn btn-primary btn-hollow pull-right"
      >
        <i className="fa fa-fw fa-plus" />
        Add
        <Create
          close={this.close}
          open={open}
          resourceID={id}
          resourceType={resourceType}
          important={important}
          minor={minor}
          trace={trace}
          notesType={notesType}
          initialValues={initialValues}
        />
      </button>
    );
  }
}

export default NewNote;



// WEBPACK FOOTER //
// ./app/modules/shared/components/Notes/CreateNote/NewNote.jsx